module.exports = __webpack_public_path__ + "static/media/l11.05d14568.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/projects/marmalade/l11.jpg
// module id = 272
// module chunks = 0